module.exports = __webpack_public_path__ + "img/11.f9feb3d1.png";